export default __webpack_public_path__ + "static/media/bus.e94cee4b.svg";